<template>
  <main>
    <hero :heading="entry.title" :subheading="entry.hero.subheading" :images="entry.heroImages" position="bottom" />
    <div class="c-section" v-if="posts">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h2 class="c-section__heading">News</h2>
        </div>
        <div class="c-toolbar">
          <div class="c-toolbar__items">
            <div class="c-toolbar__item">
              <div class="c-toolbar__heading">Sort</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="postsOrder" @change="resizeSelect" style="width:65px">
                  <option value="postDate desc">Latest</option>
                  <option value="title">Title</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item">
              <div class="c-toolbar__heading">Category</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="postsCategory" @change="resizeSelect" style="width:45px">
                  <option value="">All</option>
                  <option :value="category.id" v-for="category in postsCategories" :key="category.id">{{ category.title }}</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item">
              <div class="c-toolbar__heading">Project</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="postsProject" @change="resizeSelect" style="width:45px">
                  <option value="">All</option>
                  <option :value="project.id" v-for="project in projects" :key="project.id">{{ project.title }}</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item c-toolbar__item--right">
              <input class="c-toolbar-input" placeholder="Search" v-model="postsSearchQuery">
            </div>
          </div>
        </div>
        <ul class="o-layout o-layout--stretch o-layout--lined o-layout--large" v-if="posts.length > 0">
          <li class="o-layout__item u-1/3@tablet u-mb+" v-for="entry in posts" :key="entry.id">
            <article-card :entry="entry" />
          </li>
        </ul>
        <p v-else>Sorry, we can't find any news.</p>
      </div>
    </div>
    <div class="c-section c-section--white" v-if="articles">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h2 class="c-section__heading">Press</h2>
        </div>
        <div class="c-toolbar">
          <div class="c-toolbar__items">
            <div class="c-toolbar__item">
              <div class="c-toolbar__heading">Sort</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="articlesOrder" @change="resizeSelect" style="width:65px">
                  <option value="postDate desc">Latest</option>
                  <option value="title">Title</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item c-toolbar__item--right">
              <input class="c-toolbar-input" placeholder="Search" v-model="articlesSearchQuery">
            </div>
          </div>
        </div>
        <ul class="o-layout o-layout--stretch o-layout--lined o-layout--large" v-if="articles.length > 0">
          <li class="o-layout__item u-1/3@tablet u-mb+" v-for="entry in articles" :key="entry.id">
            <article-card :entry="entry" :link="entry.link" linkText="View article" themeGrey />
          </li>
        </ul>
        <p v-else>Sorry, we can't find any news.</p>
      </div>
    </div>
    <banner />
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'
import Banner from '@/components/Banner.vue'
import ArticleCard from '@/components/ArticleCard.vue'

export default {
  name: 'News',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    Banner: Banner,
    ArticleCard: ArticleCard
  },
  data () {
    return {
      title: '',
      entry: null,
      posts: null,
      articles: null,
      postsCategories: null,
      projects: null,
      postsOrder: 'postDate desc',
      postsCategory: '',
      postsProject: '',
      postsSearchQuery: '',
      articlesOrder: 'postDate desc',
      articlesSearchQuery: ''
    }
  },
  created () {
    this.getEntry()
    this.getPosts()
    this.getPostsCategories()
    this.getActiveProjects()
    this.getArticles()
  },
  watch: {
    postsOrder: function () {
      this.getPosts()
    },
    postsCategory: function () {
      this.getPosts()
    },
    postsProject: function () {
      this.getPosts()
    },
    postsSearchQuery: function () {
      this.getPosts()
    },
    articlesOrder: function () {
      this.getArticles()
    },
    articlesSearchQuery: function () {
      this.getArticles()
    }
  },
  methods: {
    resizeSelect (event) {
      let elem = event.target
      let selectedText = elem.options[elem.selectedIndex].text
      elem.style.width = 20 + (selectedText.length * 8) + 'px'
    },
    getEntry () {
      axios
        .get('api/postsIndex.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    },
    getPosts () {
      axios
        .get('api/posts.json?q=' + this.postsSearchQuery + '&order=' + this.postsOrder + '&category=' + this.postsCategory + '&project=' + this.postsProject)
        .then(response => (this.posts = response.data.data))
    },
    getPostsCategories () {
      axios
        .get('api/postsCategories.json')
        .then(response => (this.postsCategories = response.data.data))
    },
    getActiveProjects () {
      axios
        .get('api/activeProjects.json')
        .then(response => (this.projects = response.data.data))
    },
    getArticles () {
      axios
        .get('api/articles.json?q=' + this.articlesSearchQuery + '&order=' + this.articlesOrder)
        .then(response => (this.articles = response.data.data))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/News.vue